import { Flags } from '@anyroad/flags';
import { sendEventToSegment } from 'views/anyguide/helpers/analytics/segmentHelpers';
import { getSessionId } from 'views/plugins/tours/page/booking_details/Helpers';

function safeSessionStorageGet(key) {
  try {
    return window?.sessionStorage?.getItem(key);
  } catch (error) {
    return undefined;
  }
}

function safeSessionStorageSet(key, value) {
  try {
    return window?.sessionStorage?.setItem(key, value);
  } catch (error) {
    return undefined;
  }
}

export function trackCheckoutConfirmationArriveOnPage({
  flags,
  bookingId,
  tourId,
  guideId,
  guideName,
  checkoutFlow,
  device,
  pageName = 'Checkout Confirmation',
}) {
  if (!bookingId) return;
  if (!tourId) return;
  if (!flags?.[Flags['event-tracking-checkout-02112026-enabled']]) return;

  const storageKey = `segment:checkout:confirmation:${checkoutFlow}:${bookingId}:${pageName}`;
  if (safeSessionStorageGet(storageKey) === '1') return;

  try {
    sendEventToSegment('Arrive on page', {
      path: window.location.hash || window.location.pathname,
      referrer: document.referrer,
      session_id: getSessionId(),
      page_name: pageName,
      url: window.location.href,
      checkout_flow: checkoutFlow,
      experience_id: tourId,
      account_id: guideId,
      account_name: guideName,
      device,
    });
    safeSessionStorageSet(storageKey, '1');
  } catch (error) {
    console.log('segment tracking error', error);
  }
}
